import { RoomCardSizes } from "../../RoomCard/RoomCard"
import { useSelector } from "react-redux"
// import { useProfile } from "src/shared/hooks/useProfile"
import { RootState } from "src/store/store"

export const getSizeByRoomCount = (count: number): RoomCardSizes => {
    if (count <= 15) return "xl"
    if (count <= 35) return "md"
    if (count <= 48) return "sm"
    if (count <= 80) return "xs"
    return "xs"
}

export const useSetCardSize = (_containerRef: unknown) => {
    const { roomsGrid } = useSelector((state: RootState) => state.rooms)
    // const { configurations } = useProfile()

    // if (configurations?.cardHabitacion?.tamano_fijo) {
    //     return { size: (configurations?.cardHabitacion?.tamano || "xs") as RoomCardSizes }
    // }

    const size = getSizeByRoomCount((roomsGrid?.rows ?? 0) * (roomsGrid?.cols ?? 0))

    return { size }
}
